import { render } from "./OpportunityCard.vue?vue&type=template&id=07ea3eba"
import script from "./OpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpportunityCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__